import React from "react";
import { toggleSwitch } from "MODULES/shared/decorators";
import { Modal, Header, Close } from "MODULES/shared/components/Modal";

export function Section({
  title,
  children,
  modal,
  open,
  forceOpen,
  setForceOpen,
  visible,
  close,
  editable = true
}) {
  return [
    <h2 style={{ marginTop: 10 }} key="heading">
      {title}
      {editable && (
        <button
          type="button"
          className="btn btn-primary btn-hollow pull-right"
          onClick={open}
        >
          <i className="fa fa-fw fa-pencil">&nbsp;</i>Edit
          <Modal
            open={visible || forceOpen}
            close={close}
            dialogClass={modal.dialogClass}
          >
            <Header>
              <Close close={close} />
              <h4 className="modal-title">
                {modal.title}
                {modal.subtitle && (
                  <div>
                    <small>{modal.subtitle}</small>
                  </div>
                )}
              </h4>
            </Header>
            {modal.content(() => {
              close();
              setForceOpen && setForceOpen(false);
            })}
          </Modal>
        </button>
      )}
    </h2>,
    children
  ];
}

export default toggleSwitch("visible")(Section);



// WEBPACK FOOTER //
// ./app/modules/shared/components/Section/Section.jsx